import { ArcadeThemeColorsOverride } from './arcadeColors'

const localPalette = {
  ColorPaletteBlack: '#101010',
  ColorPaletteLightGrey: '#E8E8E8',
  ColorPaletteWhite: '#FFFFFF',
  ColorPaletteDarkGrey: '#666666',
  ColorPaletteMediumGrey: '#CCCCCC',
  ColorPaletteFadedGrey: '#F0F0F0',
  ColorPaletteDarkGreyText: '#959595',
} as const

export const localArcadeColors: Partial<ArcadeThemeColorsOverride> = {
  // Prominent button colors
  buttonProminentBackgroundDefault: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteWhite,
  },
  buttonProminentBackgroundDisabled: {
    light: localPalette.ColorPaletteMediumGrey,
    dark: localPalette.ColorPaletteMediumGrey,
  },
  buttonProminentBackgroundHover: {
    light: localPalette.ColorPaletteDarkGrey,
    dark: localPalette.ColorPaletteDarkGrey,
  },
  buttonProminentBackgroundPressed: {
    light: localPalette.ColorPaletteDarkGrey,
    dark: localPalette.ColorPaletteDarkGrey,
  },
  buttonProminentTextDefault: {
    light: localPalette.ColorPaletteWhite,
    dark: localPalette.ColorPaletteBlack,
  },
  buttonProminentTextDisabled: {
    light: localPalette.ColorPaletteDarkGreyText,
    dark: localPalette.ColorPaletteDarkGreyText,
  },
  buttonProminentTextPressed: {
    light: localPalette.ColorPaletteDarkGreyText,
    dark: localPalette.ColorPaletteDarkGreyText,
  },

  // Standard button colors
  buttonStandardBackgroundDefault: {
    light: localPalette.ColorPaletteLightGrey,
    dark: localPalette.ColorPaletteLightGrey,
  },
  buttonStandardBackgroundDisabled: {
    light: localPalette.ColorPaletteFadedGrey,
    dark: localPalette.ColorPaletteFadedGrey,
  },
  buttonStandardBackgroundHover: {
    light: localPalette.ColorPaletteMediumGrey,
    dark: localPalette.ColorPaletteMediumGrey,
  },
  buttonStandardBackgroundPressed: {
    light: localPalette.ColorPaletteMediumGrey,
    dark: localPalette.ColorPaletteMediumGrey,
  },
  buttonStandardTextDefault: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteBlack,
  },
  buttonStandardTextDisabled: {
    light: localPalette.ColorPaletteDarkGreyText,
    dark: localPalette.ColorPaletteDarkGreyText,
  },

  // Subtle button colors
  buttonSubtleBackgroundDefault: {
    light: localPalette.ColorPaletteWhite,
    dark: localPalette.ColorPaletteWhite,
  },
  buttonSubtleBackgroundDisabled: {
    light: localPalette.ColorPaletteFadedGrey,
    dark: localPalette.ColorPaletteFadedGrey,
  },
  buttonSubtleBackgroundFocus: {
    light: localPalette.ColorPaletteLightGrey,
    dark: localPalette.ColorPaletteLightGrey,
  },
  buttonSubtleBackgroundPressed: {
    light: localPalette.ColorPaletteLightGrey,
    dark: localPalette.ColorPaletteLightGrey,
  },
  buttonSubtleTextDefault: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteBlack,
  },
  buttonSubtleTextDisabled: {
    light: localPalette.ColorPaletteDarkGreyText,
    dark: localPalette.ColorPaletteDarkGreyText,
  },

  // Radio button colors
  radioActiveBorderDefault: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteWhite,
  },

  // Checkbox button olors
  checkboxActiveBackgroundDefault: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteWhite,
  },

  // Input colors
  inputBorderSelectedDefault: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteWhite,
  },
  inputCursor: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteWhite,
  },
}
